export default __webpack_public_path__ + "static/media/speech_bubble_left.869d064c.svg";